export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8883.ab0e74ab.jpg";